module.exports = __webpack_public_path__ + "static/img/yiCity.1545789.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/yiCity.png
// module id = iTM8
// module chunks = 1